module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: [
      'control',
      {
        'open': _vm.open
      }
    ]
  }, [(_vm.open) ? [_vm._v("Back")] : [_vm._v("Info")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b6f5860!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoControl.vue
// module id = 29
// module chunks = 0